import { IEmailTemplate } from "./email-template";

export interface IEmailTemplateListResponse {
    data: {
        success: boolean;
        message: string;
        results: IEmailTemplate[]
    }
}